import { Injectable } from '@angular/core';
import { DateRange } from '@com-delta-omnichannel/mach-core-js';
import { Observable, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class WidgetEventService {
  private dateChange$ = new Subject<DateRange>();
  private dateError$ = new Subject<void>();
  private passengerError$ = new Subject<string>();
  private roomError$ = new Subject<string>();
  private maxDatesError$ = new Subject<string>();
  private errorCountChange$ = new Subject<void>();
  private airportUpdate$ = new Subject<{ code: string; type: string }>();
  private airportCodeUpdate$ = new Subject<string>();

  // Observables for components to subscribe to
  readonly onDateChange$: Observable<DateRange> =
    this.dateChange$.asObservable();

  readonly onDateError$: Observable<void> = this.dateError$.asObservable();

  readonly onPassengerError$: Observable<string> =
    this.passengerError$.asObservable();

  readonly onRoomError$: Observable<string> = this.roomError$.asObservable();
  readonly onMaxDatesError$: Observable<string> =
    this.maxDatesError$.asObservable();

  readonly onErrorCountChange$: Observable<void> =
    this.errorCountChange$.asObservable();

  readonly onAirportUpdate$: Observable<{ code: string; type: string }> =
    this.airportUpdate$.asObservable();

  readonly onAirportCodeUpdate$: Observable<string> =
    this.airportCodeUpdate$.asObservable();

  // Methods to emit events
  emitDateChange(dates: DateRange): void {
    this.dateChange$.next(dates);
  }

  emitDateError(): void {
    this.dateError$.next();
  }

  emitPassengerError(error: string): void {
    this.passengerError$.next(error);
  }

  emitRoomError(error: string): void {
    this.roomError$.next(error);
  }

  emitMaxDatesError(error: string): void {
    this.maxDatesError$.next(error);
  }

  emitErrorCountChange(): void {
    this.errorCountChange$.next();
  }

  emitAirportUpdate(code: string, type: string): void {
    this.airportUpdate$.next({ code, type });
  }

  emitAirportCodeUpdate(airportCode: string): void {
    this.airportCodeUpdate$.next(airportCode);
  }
}
